import React from "react";

export const Hr: React.FC = () => (
  <hr className="h-px bg-white opacity-20 border-0" />
);
